import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

//components
import Errors from "components/auth/Errors";
import Tooltip from "components/common/tooltip/Tooltip";
import LanguageToggle from "components/common/LanguageToggle/LanguageToggle";
import SlidingTextButton from "components/common/SlidingTextButton/SlidingTextButton";

// hooks
import { useLogOut } from "components/auth/LogOut";
import { useTranslate } from "lang/Translate";

//css
import "./GroupCreation.scoped.scss";

//php
import api from "api/api";

const GroupCreation = () => {
	const [name, setName] = useState("");
	const [language, setLanguage] = useState("pl");
	const [errors, setErrors] = useState([]);

	const history = useHistory();
	const { signOut: logOut } = useLogOut();

	const createGroup = async e => {
		e.preventDefault();

		try {
			await axios.post(`${api}/group`, { name, language });
			history.push("/createAirline");
		} catch (e) {
			if (e.response.status === 409) {
				setErrors([{ error: "Wybrana nazwa jest już zajęta", errorEn: "The selected name is already taken" }]);
				return;
			}

			if (e.response.status === 422) {
				setErrors([e.response.data]);
				return;
			}

			console.error(e);
		}
	};

	return (
		<div className="group_creation">
			<LanguageToggle />
			<div className="container">
				<div>
					<h1>{useTranslate({ component: "GroupCreation", Tkey: "HEADING" })}</h1>
					<form onSubmit={e => createGroup(e)}>
						<label htmlFor="groupName">{useTranslate({ component: "GroupCreation", Tkey: "GROUP_NAME" })}</label>
						<div className="flex flex--columns flex--centerv">
							<input type="text" id="groupName" value={name} onChange={e => setName(e.target.value)} />
							<Tooltip text={useTranslate({ component: "GroupCreation", Tkey: "TOOLTIP_1" })} />
						</div>

						<label htmlFor="language">
							{useTranslate({ component: "GroupCreation", Tkey: "PREFERED_LANGUAGE" })}
						</label>
						<div className="flex flex--columns flex--centerv">
							<select id="language" value={language} onChange={e => setLanguage(e.target.value)}>
								<option value="pl">Polski</option>
								<option value="en">English</option>
							</select>
							<Tooltip text={useTranslate({ component: "GroupCreation", Tkey: "TOOLTIP_2" })} />
						</div>

						<Errors errors={errors} />

						<input type="submit" value={useTranslate({ component: "GroupCreation", Tkey: "CREATE_GROUP" })} />
					</form>
					<div>
						<SlidingTextButton
							text={useTranslate({ component: "GroupCreation", Tkey: "LOG_OUT" })}
							icon={<i className="fas fa-sign-out-alt icon" />}
							background="darkBlue"
							onClick={logOut}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GroupCreation;
